import React from 'react';
import CommentTextareaHead from './commentTextareaHead';
import CommentTextareaBody from './commentTextareaBody';
import CommentTextareaBottom from './commentTextareaBottom';
class CommentTextarea extends React.PureComponent {
    render() {
        const { headShow, content: { noAd, count, joinCount, docUrl, docName, skey, pcUrl, speUrl, guidInfo }, loginId, config, userInfo, myComUrl, commentId, onSubmit, } = this.props;
        let commentUrl = `//gentie.ifeng.com/view.html?docUrl=${docUrl}&docName=${encodeURIComponent(docName || '')}&skey=${skey}&pcUrl=${pcUrl}&speUrl=${speUrl}&${noAd ? '&noAd' : ''}`;
        if (docUrl && !docUrl.includes('//')) {
            commentUrl = `//gentie.ifeng.com/c/comment/${docUrl.replace('ucms_', '')}`;
        }
        return (React.createElement("div", null,
            headShow ? React.createElement(CommentTextareaHead, { commentUrl: commentUrl, count: count, joinCount: joinCount }) : '',
            React.createElement(CommentTextareaBody, { loginId: loginId, config: config, userInfo: userInfo, headShow: !headShow, commentId: commentId, onSubmit: onSubmit, guidInfo: guidInfo }),
            React.createElement(CommentTextareaBottom, { loginId: loginId, userInfo: userInfo, myComUrl: myComUrl })));
    }
}
CommentTextarea.defaultProps = {
    headShow: true,
};
export default CommentTextarea;
